export function isMobileScreen() {
  return document.documentElement.hasAttribute('data-mobile-screen')
}

export function canHover() {
  return window.matchMedia('(any-hover: hover)').matches
}
